export enum ChatMessageBubbleAction {
  EDIT = "edit",
  REPLY = "reply",
  DELETE = "delete",
  FORWARD = "forward",
  SHOW_REACTIONS = "show-reactions",
  SHOW_MESSAGE_INFO = "message-info",
  COPY = "copy",
  PIN = "pin",
  UNPIN = "unpin",
  SHOW = "show",
  REACTION = "reaction",
}
